import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Icon,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "investira.react.components";
import { useNavigate } from "react-router-dom";
import { RelatoriosDataGrid } from "../../organisms";
import { PageTemplate } from "../";

const ReportsTemplate = memo((props) => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  const navigate = useNavigate();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}
    >
      <RelatoriosDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState,
          density: "comfortable",
        }}
        state={state}
      />
    </PageTemplate>
  );
});

ReportsTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dataGridProps: PropTypes.object,
};

export default ReportsTemplate;
